import { useEffect } from 'react'

import { isMac } from '@sketch/utils'

const isEditableTarget = (target: EventTarget | null) => {
  if (!(target instanceof HTMLElement)) {
    return false
  }

  if (
    target instanceof HTMLInputElement ||
    target instanceof HTMLTextAreaElement ||
    target.isContentEditable
  ) {
    return true
  }

  return Boolean(target.closest('[contenteditable="true"]'))
}

interface UseCommandBarShortcutProps {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const useCommandBarShortcut = ({
  isOpen,
  onOpen,
  onClose,
}: UseCommandBarShortcutProps) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const hasModifier = isMac() ? event.metaKey : event.ctrlKey
      const isCommandBarShortcut =
        hasModifier &&
        !event.shiftKey &&
        !event.altKey &&
        event.key.toLowerCase() === 'k'

      if (!isCommandBarShortcut) {
        return
      }

      if (!isOpen && isEditableTarget(event.target)) {
        return
      }

      event.preventDefault()

      if (isOpen) {
        onClose()
        return
      }

      onOpen()
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [isOpen, onClose, onOpen])
}
